import CourseTypeGroupList from "./components/List"
import CourseTypeGroupForm from "./components/Form"
import CourseTypeGroupView from "./components/View"

let module = "coursetypegroups"

export default [
  { path: "coursetypegroups", component: CourseTypeGroupList, meta: { module: module, permissions: ["coursetypegroup-access"] } }
  /*{
    path: "coursetypegroups/create",
    component: CourseTypeGroupForm,
    props: true,
    meta: { module: module, permissions: ["coursetypegroup-create"] }
  },
  {
    path: "coursetypegroups/edit/:id",
    component: CourseTypeGroupForm,
    props: true,
    meta: { module: module, permissions: ["coursetypegroup-edit"] }
  },
  {
    path: "coursetypegroups/view/:id",
    component: CourseTypeGroupView,
    props: true,
    meta: { module: module, permissions: ["coursetypegroup-access"] }
  }*/
]
